import React, {Component} from "react"
import {withTranslate} from "react-redux-multilingual";
import Head from "../../components/Head";
import {setCurrentRoute} from "../../store/actions/globalActions";
import {connect} from "react-redux";
import globalMiddleware from "../../hocs/globalMiddleware";

class CashBack extends Component {
    componentDidMount() {
        this.props.setCurrentRoute(window.location.href);
        window.scrollTo(0, 0);
    }

    render() {
        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ];

        return (

            <div id="cash-back">
                <Head title={this.props.translate("points")} history={history}/>

                <div className="container">
                    <div className="row ">
                        <div className="col-xs-12 col-sm-12">
                            <div id="productfeatured">
                                <div className="boxApollo">

                                    <div className="apolloHeading">
                                        <h3 className="page-subheading heading-style1">
                                            {this.props.authUser !== null ? <span>{this.props.authUser.cash_back + " "} <br/> <span className="subheading-text">{this.props.translate("currency")}</span> </span>: null}
                                            <span className="description" style={this.props.language === "ar" ?  {letterSpacing: "1px"} : {letterSpacing: "6px"}}>{this.props.translate("points_title")}</span>
                                        </h3>
                                    </div>

                                    <div className="apolloDescription row clearfix">
                                        <div className="col-md-4 col-sm-12">
                                            <div className="feature-box mb-40">
                                                <div className="fbox-image">
                                                    <img
                                                        src="../images/visits.png"
                                                        alt="All terrain suitability"/>
                                                </div>
                                                <div className="fbox-content">
                                                    <div className="fbox-body">
                                                        <h4>{this.props.translate("points_benefit_one")}</h4></div>
                                                    <p className="description">{this.props.translate("points_benefit_one_desc")}</p>
                                                </div>
                                            </div>
                                            <div className="feature-box premium-box">
                                                <div className="fbox-image">
                                                    <img
                                                        src="../images/payment.png"
                                                        alt="All terrain suitability"/>
                                                </div>
                                                <div className="fbox-content">
                                                    <div className="fbox-body">
                                                        <h4>{this.props.translate("points_benefit_two")}</h4></div>
                                                    <p className="description">{this.props.translate("points_benefit_two_desc")}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-12 premium-img-tag">
                                            <img className="img-responsive full-width" alt="STROLLIK E2"
                                                 src="../images/cash-big-icon.png"
                                            />
                                        </div>
                                        <div className="col-md-4 col-sm-12">
                                            <div className="feature-box mb-40">
                                                <div className="fbox-image">
                                                    <img
                                                        src="../images/visa.png"
                                                        alt="All terrain suitability"/>
                                                </div>
                                                <div className="fbox-content">
                                                    <div className="fbox-body">
                                                        <h4>{this.props.translate("points_benefit_three")}</h4></div>
                                                    <p className="description">{this.props.translate("points_benefit_three_desc")}</p>
                                                </div>
                                            </div>
                                            <div className="feature-box">
                                                <div className="fbox-image">
                                                    <img
                                                        src="../images/points-icon.png"
                                                        alt="All terrain suitability"/>
                                                </div>
                                                <div className="fbox-content">
                                                    <div className="fbox-body">
                                                        <h4>{this.props.translate("points_benefit_four")}</h4></div>
                                                    <p className="description">{this.props.translate("points_benefit_four_desc")}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(CashBack)))